import { useState } from "react";
import { Form } from "react-bootstrap";
import { faPlus, faLocationDot, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorPopup from "../../../../../layout/ErrorPopup";
import CrmConfig from "@serie3/freelancesplaceapi/Config/Crm/CrmConfig";
import AddressesForm from "../Form/AddressesForm";
import crudApi from "@serie3/common/api/crudApi";
import listHandler from "@serie3/common/Domain/listHandler";

const AddressCard = ({ index, address, onEdit, onDelete }) => (
  <div style={{
    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
    padding: "14px 16px", borderRadius: "10px", background: "#f8f9fb",
    marginBottom: "8px", gap: "12px",
  }}>
    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", minWidth: 0 }}>
      <div style={{
        width: "34px", height: "34px", borderRadius: "8px", flexShrink: 0,
        background: "#fff8e1", display: "flex", alignItems: "center",
        justifyContent: "center", color: "#f57c00", fontSize: "0.85rem",
      }}>
        <FontAwesomeIcon icon={faLocationDot} />
      </div>
      <div>
        <div style={{ fontWeight: 700, fontSize: "0.92rem", color: "#212121", marginBottom: "2px" }}>
          {[address.strasse, address.hausnummer].filter(Boolean).join(" ")}
        </div>
        <div style={{ fontSize: "0.82rem", color: "#757575" }}>
          {[address.plz, address.ort].filter(Boolean).join(" ")}
        </div>
      </div>
    </div>
    <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
      <button type="button" onClick={onEdit}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#9e9e9e", padding: "5px 7px", borderRadius: "6px", fontSize: "0.75rem", transition: "color 0.15s, background 0.15s" }}
        onMouseOver={e => { e.currentTarget.style.color = "#1a73e8"; e.currentTarget.style.background = "#e8f0fe"; }}
        onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
      ><FontAwesomeIcon icon={faPen} /></button>
      <button type="button" onClick={onDelete}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#9e9e9e", padding: "5px 7px", borderRadius: "6px", fontSize: "0.75rem", transition: "color 0.15s, background 0.15s" }}
        onMouseOver={e => { e.currentTarget.style.color = "#c62828"; e.currentTarget.style.background = "#ffebee"; }}
        onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
      ><FontAwesomeIcon icon={faTrash} /></button>
    </div>
  </div>
);

const Adresses = ({ addressData, companyId, setAddressData, personId }) => {
  const [showEdit, setShowEdit] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [showError, setShowError] = useState(false);

  const deleteItem = (index, address) => {
    listHandler.deleteFromList(index, crudApi.del(CrmConfig.address.endpoints.delete, address.id), setAddressData, addressData, () => setShowError(true));
  };

  return (
    <>
      <ErrorPopup setShowError={setShowError} showError={showError}>
        Sorry! Something went wrong. <strong>Please contact support if this persists.</strong>
      </ErrorPopup>

      <Form>
        <AddressesForm
          showEdit={showEdit}
          setShowEdit={setShowEdit}
          editAddressData={editAddressData}
          companyId={companyId}
          personId={personId}
          dataList={addressData}
          setAddressData={setAddressData}
          showErrorFunction={() => setShowError(true)}
        />
      </Form>

      <div style={{ padding: "0 4px" }}>
        {addressData && addressData.length > 0 ? (
          addressData.map((address, index) => (
            <AddressCard
              key={index}
              index={index}
              address={address}
              onEdit={() => { setEditAddressData(address); setShowEdit(true); }}
              onDelete={() => deleteItem(index, address)}
            />
          ))
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px", color: "#bdbdbd" }}>
            <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: "2rem", marginBottom: "10px" }} />
            <span style={{ fontSize: "0.9rem" }}>No addresses yet</span>
          </div>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 4px 4px" }}>
        <button
          type="button"
          onClick={() => { setEditAddressData(null); setShowEdit(true); }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            padding: "8px 16px", background: "#e8f5e9", color: "#2e7d32",
            border: "none", borderRadius: "10px", fontWeight: 700,
            fontSize: "0.85rem", cursor: "pointer", transition: "background 0.15s",
          }}
          onMouseOver={e => e.currentTarget.style.background = "#c8e6c9"}
          onMouseOut={e => e.currentTarget.style.background = "#e8f5e9"}
        >
          <FontAwesomeIcon icon={faPlus} style={{ fontSize: "0.75rem" }} />
          Add Address
        </button>
      </div>
    </>
  );
};

export default Adresses;
